import moment from 'moment';
import InitializeAssetsController from '../../modals/intialize-assets.controller';

const EVENT_TRACKING_NAME = 'MaintenanceForm';
const EVENT_TRACKING_ACTIONS = {
  nameChanged: 'nameChanged',
  descriptionChanged: 'descriptionChanged',
  addAssetsClicked: 'addAssetsClicked',
  assetsAdded: 'assetsAdded',
  assetModelClosed: 'assetModelClosed',
  tagAdded: 'tagAdded',
  tagRemoved: 'tagRemoved',
  notifyEmailsChanged: 'notifyEmailChanged',
  scheduleTypeChanged: 'scheduleTypeChange',
  meterBasedChange: 'meterBasedChange',
  calendarBasedChange: 'calendarBasedChange',
  meterToggleClicked: 'meterToggleClicked',
  calendarToggleClicked: 'calendarToggleClicked',
  documentLinkNameChanged: 'documentLinkChanged',
  documentLinkDescriptionChanged: 'documentLinkDescriptionChanged',
  documentLinkURLChanged: 'documentLinkURLChanged',
  documentLinkAddClicked: 'documentLinkAddClicked',
  documentLinkEditToggle: 'documentLinkEditToggle',
  documentLinkRemoveClicked: 'documentLinkRemoveClicked',
  documentLinkPaginationChanged: 'documentLinkPaginationChanged',
}

const addToDataLayer = (data) => {
  window.dataLayer.push({
    event: EVENT_TRACKING_NAME,
    data: { ...data }
  });
}

export default function FormMaintenanceDirective() {
  return {
    template: require('./form.directive.html'),
    restrict: 'E',
    transclude: true,
    scope: false,
    controller: FormMaintenanceController,
  };

  function FormMaintenanceController(gettextCatalog, $scope, $uibModal, $filter) {
    'ngInject';

    let self = this;

    $scope.numSelectedAssets = 0;
    $scope.maxSelection = 1;
    $scope.assets = [];
    $scope.loading = false;
    $scope.Meter = false;
    $scope.Calendar = false;
    $scope.dateOptions = {
      initDate: moment().toDate(),
      'starting-day': 1,
    };
    //manage document link
    $scope.documentLinks = [];
    $scope.document = {};
    $scope.document.name = '';
    $scope.document.description = '';
    $scope.document.href = '';

    $scope.editDocLinkObject = [];
    $scope.disabledEditing = false;

    $scope.reverse = false;
    $scope.documentLinkIndex = 0;
    $scope.editingDocLinkFlag = []; //flag for hiding and showing info

    //Pagination for document links
    $scope.currentPage = 1;
    $scope.itemsPerPage = 5;
    $scope.maxSize = 1;

    //flag for url
    $scope.invalidUrl = false;

    $scope.planNameChanged = () => {
      // If the name is clear, change the submitted to false.
      if (!$scope.plan.name) {
        $scope.userForm.$submitted = false;
      }

      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.nameChanged,
      });

      // Clear the unique validation when changing the name.
      $scope.userForm.title.$setValidity('unique', true);
    };

    $scope.descriptionChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.descriptionChanged,
      })
    }

    $scope.dateRangeOptions = [
      {
        label: gettextCatalog.getString('Days'),
        value: 'day',
      },
      {
        label: gettextCatalog.getString('Weeks'),
        value: 'week',
      },
      {
        label: gettextCatalog.getString('Months'),
        value: 'month',
      },
      {
        label: gettextCatalog.getString('Years'),
        value: 'year',
      },
    ];

    //Constants
    $scope.meterBasedOptions = [
      {
        value: 'hour',
        label: gettextCatalog.getString('Run Hours'),
      },
      {
        value: 'miles',
        label: gettextCatalog.getString('Miles'),
      },
      {
        label: gettextCatalog.getString('Kilometers'),
        value: 'kilometers',
      },
    ];

    $scope.$emit('disableMeter', {
      Meter: $scope.Meter,
    });
    $scope.$emit('disableDate', {
      Calendar: $scope.Calendar,
    });

    self.getCalendarRules = function () {
      let result = [];
      if (!$scope.plan) {
        result = [];
      }
      $scope.Calendar = false;
      for (let i = 0; i < $scope.plan.recurrence.rules.length; i++) {
        if ($scope.plan.id) {
          if ($scope.plan.recurrence.rules[i].type === 'date') {
            $scope.Calendar = true;
            result.push($scope.plan.recurrence.rules[i]);
          }
        }
      }

      if (!result || result.length <= 0) {
        $scope.calendarDisabled = true;
        $scope.Calendar = false;
        result = [
          {
            type: 'date',
            frequency: 'month',
            interval: 3,
            upcoming: 2,
          },
        ];
      }

      $scope.calendarRules = result;
    };

    self.getMeterRules = function () {
      let result = [];

      if (!$scope.plan) result = [];

      if (!$scope.plan.id) {
        $scope.meterDisabled = true;
        $scope.calendarDisabled = true;
      }

      $scope.Meter = false;
      for (let i = 0; i < $scope.plan.recurrence.rules.length; i++) {
        if ($scope.plan.id) {
          if (
            $scope.plan.recurrence.rules[i].type === 'odometer' ||
            $scope.plan.recurrence.rules[i].type === 'runhour'
          ) {
            $scope.Meter = true;
          }
        }
        let rule = $scope.plan.recurrence.rules[i];

        for (let j = 0; j < $scope.meterBasedOptions.length; j++) {
          if (rule.frequency === $scope.meterBasedOptions[j].value) {
            if (rule.frequency === 'hour') {
              rule.type = 'runhour';
            } else if (rule.frequency === 'miles' || rule.frequency === 'kilometers') {
              rule.type = 'odometer';
            }
            result.push(rule);
          }
        }
      }

      if (!result || result.length <= 0) {
        $scope.meterDisabled = true;
        $scope.Meter = false;
        result = [
          {
            type: 'runhour',
            frequency: 'hour',
            interval: 1000,
            upcoming: 50,
          },
        ];
      }
      $scope.meterRules = result;
    };

    self.refresh = function () {
      if ($scope.plan) {
        $scope.documentLinks = $scope.plan.documentLinks;
      }
      self.getMeterRules();
      self.getCalendarRules();
    };

    $scope.toggleFixed = function () {
      const fixedType = 'Fixed';

      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.scheduleTypeChanged,
        scheduleType: fixedType,
      });

      $scope.plan.recurrence.algorithm = fixedType;
    };

    $scope.toggleOffset = function () {
      const offsetType = 'Offset';

      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.scheduleTypeChanged,
        scheduleType: offsetType,
      });

      $scope.plan.recurrence.algorithm = 'Offset';
    };

    $scope.$watch('plan', function (val) {
      if (val) self.refresh();
    });

    $scope.deleteRule = function (rule) {
      let index = $scope.plan.recurrence.rules.indexOf(rule);
      if (index >= 0) $scope.plan.recurrence.rules.splice(index, 1);
    };

    $scope.addAssets = () => {
      // Maintenace GTM tracking
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.addAssetsClicked,
      });

      $scope.errorFlag = false;
      let modalInstance = $uibModal.open({
        animation: true,
        template: require('../../../../../components/assetpicker/asset.multi.picker.html'),
        controller: 'AssetMultiPickerController',
        resolve: {
          singleSelect: false,
          requiresSelection: true,
          maxSelection: () => 0,
          selectedAssets: () => $scope.assets,
        },
        size: 'lg',
      });
      modalInstance.result.then(retrieveSelectedAssets, canceledModal);
    };

    const retrieveSelectedAssets = (selectedAssets) => {
      const numOfAssets = selectedAssets.result ? Object.keys(selectedAssets.result).length : 0;

      // Maintenance GTM tracking
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.assetsAdded,
        numberOfAssets: numOfAssets,
      });

      if (numOfAssets > 0) {
        $scope.assets = selectedAssets.result;
        $scope.numSelectedAssets = numOfAssets;
        let assetIds = Object.getOwnPropertyNames(selectedAssets.result);
        openServiceModal(assetIds);
      }
    };

    const canceledModal = (reason) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.assetModelClosed,
        reason: reason || ''
      })
    }

    const openServiceModal = (assetIds) => {
      let modalInstance = $uibModal.open({
        animation: true,
        bindToController: true,
        size: 'lg',
        template: require('../assets/add-asset.html'),
        controller: InitializeAssetsController,
        resolve: {
          selected: () => ({ added: assetIds }),
        },
      });
      modalInstance.result.then(addToEquipmentChangeSet, () => { });
    };

    const addToEquipmentChangeSet = (assetResult) => {
      $scope.equipmentChangeSet = {
        op: 'add',
        values: [],
      };

      assetResult.assets.forEach((asset) => {
        let assetObject = {
          equipmentId: asset.asset.id,
          initializeWith: asset.serviceReading,
        };
        if (assetResult.setDateForAll === true)
          assetObject.initializeWith.date = assetResult.defaultServiceDate;

        $scope.equipmentChangeSet.values.push(assetObject);
      });
    };

    $scope.tagAdded = (tag) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.tagAdded,
        numOfTags: $scope.plan.tags?.length || 0,
      })
    }

    $scope.tagRemoved = (tag) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.tagRemoved,
        numOfTags: $scope.plan.tags?.length || 0,
      })
    }
    $scope.emailsChanged = (emails) =>  {
      $scope.plan.contacts = emails;

      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.notifyEmailsChanged,
        numberOfEmails: $scope.plan.contacts.length || 0,
      })

    }

    $scope.toggleMeterRules = function () {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.meterBasedChange,
      });
      $scope.$emit('disableMeter', {
        Meter: $scope.Meter,
      });
    };

    $scope.toggleCalendarRules = function () {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.calendarToggleClicked,
      });
      $scope.$emit('disableDate', {
        Calendar: $scope.Calendar,
        CalendarRules: $scope.calendarRules,
      });
    };

    $scope.$watch('meterRules', function () {
      $scope.$emit('meterRulesChange', {
        MeterRules: $scope.meterRules,
      });
    });

    $scope.$watch('calendarRules', function () {
      $scope.$emit('calendarRulesChange', {
        CalendarRules: $scope.calendarRules,
      });
    });

    $scope.greaterThanZeroCheck = function (value, component) {
      if (value > 0) {
        component.$setValidity('min', true);
      } else {
        component.$setValidity('min', false);
      }
    };

    $scope.negativeCheck = function (value, component) {
      if (value >= 0) {
        component.$setValidity('min', true);
      } else {
        component.$setValidity('min', false);
      }
    };

    $scope.validateUpcoming = function (component, interval, frequency) {
      if (frequency.match(/^(hour|miles|kilometers)$/))
        $scope.isMeterUpcomingGreat = (component.$modelValue > interval ? true : false);

      if (!frequency.match(/^(day)$/)) {
        $scope.isCalendarUpcomingGreat = false;
      } else {
        $scope.isCalendarUpcomingGreat = (component.$modelValue > interval ? true : false);
      }
    };
    $scope.meterDueInputChanged = (interval) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.meterBasedChange,
        dueInterval: interval
      });
    }

    $scope.meterUpcomingChanged = (interval) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.meterBasedChange,
        upcomingInterval: interval
      });
    }

    $scope.meterOptionChanged = (frequency) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.meterBasedChange,
        unitOfMeasure: frequency,
      });
    }

    $scope.calendarDueInputChanged = (interval) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.calendarBasedChange,
        dueInterval: interval
      })
    }

    $scope.calendarUpcomingInputChanged = (interval) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.calendarBasedChange,
        upcomingInterval: interval
      });
    }

    $scope.calendarOptionChanged = (frequency) => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.calendarBasedChange,
        unitOfMeasure: frequency,
      });
    }

    //add new document link
    $scope.addNewDocumentLink = function (document) {
      if (
        document.name.length <= 0 &&
        document.description.length <= 0 &&
        document.href.length <= 0
      ) {
        return;
      }

      if (!validateUrl(document.href)) {
        $scope.invalidUrl = true;
        return;
      } else {
        $scope.invalidUrl = false;
      }

      $scope.document = document;

      if (!$scope.documentLinks) {
        $scope.documentLinks = [];
      }
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkAddClicked,
      });

      $scope.documentLinks.push({
        name: $scope.document.name,
        description: $scope.document.description,
        href: $scope.document.href,
      });
      $scope.document.name = '';
      $scope.document.description = '';
      $scope.document.href = '';
    };
    
    $scope.documentLinkNameChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkNameChanged,
      });
    }

    $scope.documentLinkDescriptionChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkDescriptionChanged,
      });
    }

    $scope.documentLinkURLChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkURLChanged,
      });
    }

    $scope.deleteBtnClicked = function (index) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkRemoveClicked,
        index: index,
      });
      $scope.documentLinks.splice(index, 1);
    };

    //Editing document link
    $scope.toggleEditing = function (index) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkEditToggle,
        index: index,
      });

      $scope.editingDocLinkFlag[index] = !$scope.editingDocLinkFlag[index];
      $scope.editDocLinkObject[index] = {};
      $scope.editDocLinkObject[index].name = $scope.documentLinks[index].name;
      $scope.editDocLinkObject[index].description = $scope.documentLinks[index].description;
      $scope.editDocLinkObject[index].href = $scope.documentLinks[index].href;
      $scope.disabledEditing = true;
    };

    $scope.documentLinkPaginationChanged = () => {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkPaginationChanged,
        currentPage: $scope.currentPage,
      })
    }

    $scope.cancelEdit = function (index) {
      addToDataLayer({
        action: EVENT_TRACKING_ACTIONS.documentLinkEditToggle,
        index: index,
      })
      $scope.editingDocLinkFlag[index] = !$scope.editingDocLinkFlag[index];
      $scope.editDocLinkObject[index] = {};
      $scope.disabledEditing = false;
    };

    $scope.updateDocumentLink = function (documentLink, index) {
      $scope.documentLinks[index] = documentLink;
      if (!validateUrl(documentLink.href)) {
        $scope.invalidEditUrl = true;
        return;
      } else {
        $scope.invalidEditUrl = false;
        $scope.editingDocLinkFlag[index] = !$scope.editingDocLinkFlag[index];
        $scope.editDocLinkObject[index] = {};
        $scope.disabledEditing = false;
      }
    };

    //validate url for maintenance doc link
    let validateUrl = (url) => {
      //var url = url.toLowerCase();
      let urlPattern = new RegExp('https?://([-a-z.A-Z0-9@:%_+.~#?&//=]*)');
      let validUrl = url.toLowerCase().match(urlPattern);
      return validUrl; //return true if valid ; flase if invalid
    };

    //calculate the index for array object
    $scope.getIndex = function (index) {
      return ($scope.currentPage - 1) * $scope.itemsPerPage + index;
    };

    //Sort doc links
    $scope.orderDocumentLinksFilter = function (predicate) {
      if (predicate === $scope.predicate) {
        $scope.reverse = !$scope.reverse;
      } else {
        $scope.reverse = false;
      }
      $scope.predicate = predicate;

      $scope.documentLinks.forEach((docLinks) => {
        docLinks[predicate] = docLinks[predicate];
      });

      $scope.documentLinks = $filter('orderBy')($scope.documentLinks, predicate, $scope.reverse);
    };
  }
}
